export const WHO_IS_THIS_PROGRAM_FOR_1_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Program For Items",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_title: "Fresh Finance Graduate",
    meta_title_color: "#FFFFFF",
    meta_title_hover_color: "#4CECFA",
    meta_description: "",
    meta_description_color: "#FFFFFF",
    meta_image: "",
    meta_priority: 1,
  },

  WHO_IS_THIS_PROGRAM_FOR_FIELDS_CONFIG: [
    {
      fieldName: "design_variant",
      label: "Design Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select design variant",
      helperText:
        "Switches the design (colours, fonts, spacing). Variant 1 is the current dark theme; Variant 2 is the light theme.",
      required: false,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
      ],
    },
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop background color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile background color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Background Variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 1",
      required: false,
      defaultValue: "#00D4EB",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 2",
      required: false,
      defaultValue: "#222222",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 3",
      required: false,
      defaultValue: "#222222",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "#5345C3",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 4",
      required: false,
      defaultValue: "#5345C3",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "pre_title",
      label: "Pre Title",
      value: "Built for Ambitious ",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Pre Title",
      required: false,
      defaultValue: "Built for Ambitious ",
    },
    {
      fieldName: "pre_title_color",
      label: "Pre Title Color",
      value: "#FFFFFFCC",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Pre Title Color (e.g., #FFFFFF)",
      defaultValue: "#FFFFFFCC",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "title",
      label: "Title",
      value: "Finance Professionals ",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title",
      required: false,
      defaultValue: "Finance Professionals",
    },
    {
      fieldName: "title_start_color",
      label: "Title Start Color (Gradient)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "title_end_color",
      label: "Title End Color (Gradient)",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#02A7B6",
      required: false,
      defaultValue: "#02A7B6",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "title_gradient_angle",
      label: "Title Gradient Angle",
      value: "90deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient angle (e.g., 90deg, 180deg)",
      defaultValue: "90deg",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "description",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Description",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description_color",
      label: "Description Color",
      value: "#FFFFFFB2",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Description Color (e.g., #FFFFFF)",
      defaultValue: "#FFFFFFB2",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "cta_text",
      label: "CTA Button Text",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA Button Text",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "cta_color",
      label: "CTA Button Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "cta_text_color",
      label: "CTA Button Text Color",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA text color (e.g., #222222)",
      required: false,
      defaultValue: "#222222",
      showWhen: { field: "design_variant", equals: "variant_1" },
    },
    {
      fieldName: "v2_background_color",
      label: "Background Color (Variant 2)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
      showWhen: { field: "design_variant", equals: "variant_2" },
    },
    {
      fieldName: "v2_heading_color",
      label: "Heading Color (Variant 2)",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter heading color (e.g., #101112)",
      required: false,
      defaultValue: "#101112",
      showWhen: { field: "design_variant", equals: "variant_2" },
    },
    {
      fieldName: "v2_description_color",
      label: "Description Color (Variant 2)",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description color (e.g., #101112)",
      required: false,
      defaultValue: "#101112",
      showWhen: { field: "design_variant", equals: "variant_2" },
    },
    {
      fieldName: "v2_accent_color",
      label: "Accent Color (Variant 2)",
      value: "#9F1C34",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter accent color (e.g., #9F1C34)",
      helperText:
        "Used for the active card title, its top/bottom border, its faint background tint, and the Apply Now button.",
      required: false,
      defaultValue: "#9F1C34",
      showWhen: { field: "design_variant", equals: "variant_2" },
    },
    {
      fieldName: "v2_card_title_color",
      label: "Inactive Card Title Color (Variant 2)",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter inactive card title color (e.g., #000000)",
      helperText: "Also used for the thin divider under each inactive card.",
      required: false,
      defaultValue: "#000000",
      showWhen: { field: "design_variant", equals: "variant_2" },
    },
    {
      fieldName: "v2_button_text_color",
      label: "Button Text Color (Variant 2)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter button text color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
      showWhen: { field: "design_variant", equals: "variant_2" },
    },
    {
      fieldName: "status",
      label: "Section Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Section",
      defaultValue: true,
    },
    {
      fieldName: "enable_animation",
      label: "Enable Animation",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable animation",
      required: false,
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Item Title",
      required: true,
      defaultValue: "",
    },
    {
      header: "Title Color",
      fieldName: "meta_title_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Title Color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      header: "Title Hover Color",
      fieldName: "meta_title_hover_color",
      value: "#4CECFA",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Title Hover Color",
      required: false,
      defaultValue: "",
    },
    {
      header: "Description",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Description",
      required: false,
      defaultValue: "",
    },
    {
      header: "Description Color",
      fieldName: "meta_description_color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Description Color",
      required: false,
      defaultValue: "",
    },
    {
      header: "Image",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Image",
      required: false,
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
      defaultValue: 1,
    },
  ],
};
